const Streaming = () => {
  return (
    <div>
      <h1>Streaming</h1>
    </div>
  );
};

export default Streaming;
